import { RecipePreview } from '@/types';
import { Link } from '@inertiajs/react';
import { useLocalizedRoute } from '@/hooks/localizedRoute';
import { ProfileImage } from '@/Components/Specific';
import { Difficulty } from './Show';
import { UI } from '@/Components/UI';
import { Trans, useTranslation } from 'react-i18next';

type RecipeCardProps = {
    recipe: RecipePreview;
}

export const RecipeCard = ({ recipe }: RecipeCardProps) => {
    const { t } = useTranslation(['recipes']);
    const { localizedRoute } = useLocalizedRoute();

    return (
        <div className={'@container'}>
            <Link
                className={'group size-full grid grid-rows-[min-content_auto] @md:grid-cols-2 @md:grid-rows-1 gap-2 rounded-2xl bg-surface-1 p-2 transition-all duration-200 hover:bg-secondary-container active:rounded-3xl'}
                href={localizedRoute('recipes.show', { recipe: recipe.slug })}>
                <div>
                    <UI.Image
                        image={recipe.titleImage}
                        alt={recipe.title}
                        className={'aspect-4/3 rounded-xl transition-all duration-200 group-active:rounded-2xl'}
                    />
                </div>

                <div className={'flex flex-col justify-between gap-4'}>
                    <div className={'flex flex-col gap-1'}>
                        <UI.Heading
                            level={3}
                            className={'line-clamp-2 grow mt-0 text-lg text-on-surface group-hover:text-on-secondary-container'}>
                            {recipe.title}
                        </UI.Heading>

                        <div
                            className={'flex flex-row items-center gap-1 text-on-surface text-opacity-60 group-hover:text-on-secondary-container'}>
                            <ProfileImage
                                user={recipe.author} />

                            <span className={'line-clamp-1 text-ellipsis'}>
                                {recipe.author.name}
                            </span>
                        </div>
                    </div>

                    <div
                        className={'flex flex-row justify-between text-on-surface text-opacity-60 group-hover:text-on-secondary-container'}>
                        <span>
                            <Difficulty
                                difficulty={recipe.difficulty} />
                        </span>

                        <span>
                            <Trans t={t} i18nKey={'preparationTime.value'}>
                                <UI.Number value={recipe.preparationTime} preset={'decimal'} /> minutes
                            </Trans>
                        </span>
                    </div>
                </div>
            </Link>
        </div>
    );
};
